export function formatHours(hours: number | null | undefined): string {
  if (hours == null) return "—";
  const totalMinutes = Math.round(hours * 60);
  if (totalMinutes === 0) return "0h";
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}
